import {
    SAVE_USER,
    SAVE_USER_ID,
    SAVE_USER_TYPE,
    SET_ADDRESS_VALUE,
    SET_CITY_VALUE,
    SET_CP_VALUE,
    SET_EMAIL_VALUE,
    SET_ERROR_MESSAGE,
    SET_NEW_PASSWORD_VALUE,
    SET_PASSWORD_VALUE,
    SET_PHONE_VALUE,
    SET_REDIRECTION,
    SET_RESET_USER_INFOS,
    SET_SOUSCRIPTION,
    SET_SUCCESS_MESSAGE,
    SET_VERIFY_PASSWORD_VALUE
} from "../actions/user";

export const initialState = {
    email: "",
    password: "",
    verifiedPassword: "",
    newPasswordValue: "",
    errorMessage: "",
    successMessage: "",
    passwordError: false,
    emailExist: false,
    emailError: false,
    emailToCreate: false,
    dataUser: {},
    userType: "",
    redirection: null,
    tel: "",
    city: "",
    cp: "",
    address: "",
    isSouscription: false,
    resetUserInfos: false,
    societe: {
        id: 0,
        title: "",
        text: "",
        button: ""
    },
};

const user = (state = initialState, action = {}) => {
    switch (action.type) {
        // Actions permettant de mettre à jours les coordonnées du user
        case SET_EMAIL_VALUE : {
            return {
                ...state,
                dataUser: {...state.dataUser, email: action.value},
            };
        }
        case SET_PHONE_VALUE : {
            return {
                ...state,
                dataUser: {...state.dataUser, tel: action.value},
            };
        }
        case SET_CITY_VALUE : {
            return {
                ...state,
                dataUser: {...state.dataUser, city: action.value},
            };
        }
        case SET_CP_VALUE : {
            return {
                ...state,
                dataUser: {...state.dataUser, cp: action.value},
            };
        }
        case SET_ADDRESS_VALUE : {
            return {
                ...state,
                dataUser: {...state.dataUser, adress: action.value},
            };
        }
        case SET_PASSWORD_VALUE : {
            return {
                ...state,
                password: action.value
            };
        }
        case SET_VERIFY_PASSWORD_VALUE : {
            return {
                ...state,
                verifiedPassword: action.value
            };
        }
        case SET_NEW_PASSWORD_VALUE : {
            return {
                ...state,
                newPasswordValue: action.value
            };
        }
        case SET_ERROR_MESSAGE: {
            return {
                ...state,
                errorMessage: action.msg
            };
        }
        case SET_SUCCESS_MESSAGE: {
            return {
                ...state,
                successMessage: action.msg
            };
        }
        // Action permettant de sauvegarder les informations renvoyé
        case SAVE_USER : {
            return {
                ...state,
                dataUser: action.dataUser,
            };
        }
        case SAVE_USER_ID : {
            return {
                ...state,
                idUser: action.idUser
            };
        }
        case SAVE_USER_TYPE : {
            return {
                ...state,
                userType: action.userType
            };
        }
        // Détermine si une redirection vers le module login doit être exécuté
        case SET_REDIRECTION : {
            return {
                ...state,
                redirection: action.bool
            };
        }
        // Permet d'enregistrer une souscriptions pour l'envoyer à l'API
        case SET_SOUSCRIPTION : {
            return {
                ...state,
                dataUser: {
                    ...state.dataUser,
                    isSouscription: action.bool
                },
                isSouscription: action.bool
            };
        }
        // Détermine si le user à cliquer sur "corriger" ses coordonnées via la modal de paiement par carte bancaire
        case SET_RESET_USER_INFOS : {
            return {
                ...state,
                resetUserInfos: action.bool
            };
        }
        // case SET_SOCIETE : {
        //     return {
        //         ...state,
        //         societe: {
        //             ...state.societe,
        //             id: action.data
        //         },
        //     };
        // }
        // case GET_SOCIETE : {
        //     return {
        //         ...state,
        //         societe: {
        //             ...state.societe,
        //             id: action.data
        //         },
        //     };
        // }
        default:
            return state;
    }
};

export default user;